$.fn.fetchDuration = function(options){
    var defaults = {
      obj: $(this),
      objToAppend: $(this).data("youtube-fetch-duration"),
      src: $(this).attr("href"),
      apiKey: "AIzaSyAAA0sqlisqN5Ys4aZj69Y-eI-oxjYI9A4"
    }
    var settings = $.extend(defaults, options);
    var youtubeId = settings.src.split("=")[1];
    var youtubeUrl = "https://www.googleapis.com/youtube/v3/videos?id=" + youtubeId
    + "&key=" + settings.apiKey + "&part=snippet,contentDetails&origin=http://esports.vng.games";
    $.ajax({
        async: false,
        type: 'GET',
        url: youtubeUrl,
        success: function(data) {
            var youtube_time = data.items[0].contentDetails.duration;
            var duration = covtime(youtube_time);
            settings.obj.find(settings.objToAppend).html(duration);

        //   var img = data.items[0].snippet.thumbnails.high.url;
        //   ifr.find('.game-cover').attr({
        //   	src: img,
        //   });
        }
    });
}

function covtime(youtube_time){
	var formatted;
  	array = youtube_time.match(/(\d+)(?=[MHS])/ig)||[];
    var format = array.map(function(item){
        if(item.length < 2) {
        	return '0' + item;
        }
        return item;
    }).join(':');

    if(format.length == 2) {
    	formatted = '00:00:' + format;
    }else {
    	if(format.length == 5) {
    		formatted = '00:' + format;
    	}else {
			formatted = format;
		}
    }
    return formatted;
}